
import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import { languageConfig } from '../../i18n';
import { Globe } from 'lucide-react';

interface LanguageToggleProps {
    variant?: 'floating' | 'inline';
    className?: string;
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({
    variant = 'floating',
    className = ''
}) => {
    const { language, toggleLanguage } = useLanguage();
    const isCustomer = !window.location.pathname.match(/^\/(admin|manager|waiter|cashier|login)/);
    const languageSelected = localStorage.getItem('india-place-language-selected') === 'true';

    if (isCustomer && languageSelected) return null;

    const nextLang = language === 'ar' ? 'en' : 'ar';

    if (variant === 'inline') {
        return (
            <button
                onClick={toggleLanguage}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-xl bg-gray-100 hover:bg-gray-200 transition-colors ${className}`}
            >
                <Globe size={16} className="text-gray-500" />
                <span className="text-xs font-bold text-gray-700">
                    {languageConfig[nextLang].nativeName}
                </span>
            </button>
        );
    }

    // Floating variant (default)
    return (
        <button
            onClick={toggleLanguage}
            className={`
                fixed bottom-6 z-50
                ${language === 'ar' ? 'left-6' : 'right-6'}
                flex items-center justify-center gap-2
                w-14 h-14 rounded-full
                bg-accent text-white shadow-2xl shadow-accent/30
                hover:scale-110 active:scale-95 transition-transform
                ${className}
            `}
            title={`Switch to ${languageConfig[nextLang].name}`}
        >
            <span className="text-sm font-bold">
                {language === 'ar' ? 'EN' : 'ع'}
            </span>
        </button>
    );
};
